import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useDispatchTrackEvent } from '@grandvisionhq/svc-tealium/events';
import { NonRxProductAddToCartButton } from '../NonRxProductAddToCartButton/NonRxProductAddToCartButton.js';

const NonRxProductCTA = ({ action , addToCartConfig , storesRoute , handleConversionEvent ,  })=>{
    const { getLabel  } = useIntl();
    const dispatchTrackEvent = useDispatchTrackEvent();
    const findStoreOpenEvent = ()=>Promise.resolve({
            id: 'Impression',
            Page_Section2: 'FisPdp',
            Events_FindStoreOpen: '1'
        })
    ;
    const onHandleClick = ()=>{
        dispatchTrackEvent(findStoreOpenEvent);
        handleConversionEvent === null || handleConversionEvent === void 0 ? void 0 : handleConversionEvent();
    };
    if (action === 'ADD_TO_CART') {
        // Add to Cart button
        return /*#__PURE__*/ React.createElement(NonRxProductAddToCartButton, swcHelpers.extends({}, addToCartConfig));
    }
    // Find a Store button
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: onHandleClick,
        caption: getLabel('products.actions.excludedFromCheckout'),
        "data-t": "btn-excluded-from-checkout",
        href: storesRoute
    });
};

export { NonRxProductCTA };
//# sourceMappingURL=NonRxProductCTA.js.map
